import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-label="lpu"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={19}
    fill="none"
    {...props}
  >
    <path fill="#F13200" d="M11,5v6H5V5H11 M12,4H4v8h8V4L12,4z" />
    <path
      fill="#989898"
      d="M14,0H2C0.9,0,0,0.9,0,2v12c0,1.1,0.9,2,2,2h10.4l3.6,3v-5V2C16,0.9,15.1,0,14,0z M10,14H2V2h12v12H10z"
    />
  </svg>
);
export default SvgComponent;
